import { createContext, useContext, useState } from "react";

interface MemberCountContextValue {
  memberCount: number;
  setMemberCount: (count: number) => void;
}

const MemberCountContext = createContext<MemberCountContextValue | null>(null);

MemberCountContext.displayName = "MemberCountContext";

export const useMemberCount = () => {
  const context = useContext(MemberCountContext);
  if (!context) {
    throw new Error("useMemberCount must be used within a MemberCountProvider");
  }
  return context;
};

interface MemberCountProviderProps {
  children: React.ReactNode;
}

export const MemberCountProvider = ({ children }: MemberCountProviderProps) => {
  const [memberCount, setMemberCount] = useState(0);

  return (
    <MemberCountContext.Provider value={{ memberCount, setMemberCount }}>
      {children}
    </MemberCountContext.Provider>
  );
};
